var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m472.395 152.227-224.559-149.705c-5.029-3.363-11.579-3.363-16.608 0l-224.558 149.705c-4.167 2.778-6.667 7.456-6.667 12.456v269.47c0 24.766 20.146 44.912 44.912 44.912h389.235c24.766 0 44.912-20.146 44.912-44.912v-269.47c-.001-5-2.501-9.678-6.667-12.456zm-232.862-119.252 197.57 131.709-197.57 131.709-197.571-131.709s197.571-131.709 197.571-131.709zm194.617 416.148h-389.235c-8.26 0-14.971-6.71-14.971-14.971v-241.496l201.284 134.189c2.515 1.681 5.409 2.515 8.304 2.515s5.789-.833 8.304-2.515l201.284-134.189v241.497c.001 8.26-6.71 14.97-14.97 14.97z"}));
}

Email.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 479.065 479.065","height":"512","viewBox":"0 0 479.065 479.065","width":"512"};

module.exports = Email;

Email.default = Email;
